module.exports = __webpack_public_path__ + "img/point-coins.76ac6fe9.png";